import LocalizedStrings from "react-localization";
import th from "./th";
import en from "./en";

const Messages: any = new LocalizedStrings({
    en,
    // th,
});

export default Messages;
